import { PDE } from "../http/urls";

// export const postLogIn = async (payload) => {
//     const res = await PDE.post("api/v1/password-login", payload, {
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json;charset=UTF-8",
//       },
//     });
//     return res;
//   };
export const postLogIn = async (payload) => {
    try {
      const res = await PDE.post("api/v1/password-login", payload, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
      });
      return res;
    } catch (error) {
      console.error('Login Error:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message
      });
      throw error;
    }
  };
  
  export const checkSessionAPI = async () => {
    const res = await PDE.get("api/v1/checksession-client", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("AdminHeaven")}`,
      },
    });
    return res;
  };